'use strict';

var App = require('app');
var Consts = require('consts');
var i18n = require('utils/i18n');
var Misc = require('utils/misc');

var SelectHCsDialogView = Marionette.ItemView.extend({
    template: require('components/scheme/templates/select_hcs_dialog'),

    events: {
        'click button#js-save': 'saveClicked',
    },

    initialize: function (options) {
        this.availableHCs = options.availableHCs || [];
        this.selectedHCs = options.selectedHCs || [];
        this.hcNames = options.hcNames || {};
    },

    serializeData: function () {
        var availableHCs = [];
        var selectedHCs = [];
        var self = this;
        _.each(this.availableHCs, function (hc) {
            var obj = {
                uniqueId: hc,
                name: self.hcNames[hc] || Consts.DefaultCircuitNames[hc],
            };
            availableHCs.push(obj);
            if (self.selectedHCs.includes(hc)) {
                selectedHCs.push(obj);
            }
        });
        return {
            availableHCs: availableHCs,
            selectedHCs: selectedHCs,
        };
    },

    onRender: function () {
        this.initializeSelectPicker();
        $('.modal-dialog').addClass('modal-lg');
    },

    onShow: function () {
        this.initializeSelectPicker();
    },

    onBeforeDestroy: function () {
        $('.modal-dialog').removeClass('modal-lg');
    },

    initializeSelectPicker: function () {
        Misc.initSelectPicker();
    },

    saveClicked: function (e) {
        e.preventDefault();
        App.hideModal();
        var selection = $('#hcs-multi-select').val() || [];
        this.options.save_cb(selection);
    },

    onAttach: function () {
        this.initializeMultiSelect();
    },

    onRender: function () {
        this.initializeMultiSelect();
    },

    initializeMultiSelect: function () {
        Misc.initializeMultiSelect('#hcs-multi-select', i18n.TR('Verfügbar'), i18n.TR('Ausgewählt'), false);
    },
});

module.exports = SelectHCsDialogView;
